export const STATE_KEY = 'engagementDashboard'

export const SET_ENGAGEMENT_DASHBOARD = 'SET_ENGAGEMENT_DASHBOARD'
export const SET_ENGAGEMENT_LOADING = 'SET_ENGAGEMENT_LOADING'
export const SET_ENGAGEMENT_ERROR = 'SET_ENGAGEMENT_ERROR'
export const SET_ENGAGEMENT_ZIPCODE = 'SET_ENGAGEMENT_ZIPCODE'
export const SET_ENGAGEMENT_ZIPCODE_LOADING = 'SET_ENGAGEMENT_ZIPCODE_LOADING'

const initialState = {
  loading: false,
  hasLoaded: false,
  error: null,
  results: null,
  dataAsOf: null,
  dataFreshness: null,
  cardClicks: [],
  cardViews: [],
  startDate: null,
  endDate: null,
  mapPins: [],
  mapLoading: false,
}

export default function engagementDashboardReducers(state = initialState, action) {
  switch (action.type) {
    case SET_ENGAGEMENT_LOADING:
      return { ...state, loading: true, error: null }

    case SET_ENGAGEMENT_DASHBOARD:
      return {
        ...state,
        loading: false,
        hasLoaded: true,
        error: null,
        results: action.payload.results,
        cardClicks: action.payload.card_clicks || [],
        cardViews: action.payload.card_views || [],
        startDate: action.payload.start_date,
        endDate: action.payload.end_date,
        // Freshness watermark: last day the engagement series is built through.
        // Absent on older API builds -> null, and the chart falls back.
        dataAsOf: action.payload.data_as_of || null,
        dataFreshness: action.payload.data_freshness || null,
      }

    case SET_ENGAGEMENT_ERROR:
      return { ...state, loading: false, hasLoaded: true, error: action.payload }

    case SET_ENGAGEMENT_ZIPCODE_LOADING:
      return { ...state, mapLoading: true }

    case SET_ENGAGEMENT_ZIPCODE:
      return {
        ...state,
        mapLoading: false,
        mapPins: action.payload.pins || [],
      }

    default:
      return state
  }
}
